export * from '@mui/icons-material';

const AssetPriorityFlagBlue = '/icons/priority_flags/flag-blue.png';
const AssetPriorityFlagGrey = '/icons/priority_flags/flag-grey.png';
const AssetPriorityFlagOrange = '/icons/priority_flags/flag-orange.png';
const AssetPriorityFlagRed = '/icons/priority_flags/flag-red.png';

const AssetCalendarToday = '/icons/calendar/today.png';
const AssetCalendarTomorrow = '/icons/calendar/tomorrow.png';
const AssetCalendarWeekend = '/icons/calendar/weekend.png';
const AssetCalendarNextWeek = '/icons/calendar/next_week.png';

export {
  AssetPriorityFlagBlue,
  AssetPriorityFlagGrey,
  AssetPriorityFlagOrange,
  AssetPriorityFlagRed,

  AssetCalendarToday,
  AssetCalendarTomorrow,
  AssetCalendarWeekend,
  AssetCalendarNextWeek,
};
